// Foundations
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// rxjs
import { Observable } from 'rxjs';
import { map } from 'rxjs';

// Extensions
import {
  EmbeddedResponse,
  SignatureRequest,
  SignatureRequestResponse,
} from 'hellosign-sdk';

// ENV
import { environment } from '../../environments/environment';

const {
  camUrl,
  // helloSign: {
  //   url: HELLO_SIGN_URL,
  //   credentials: HELLO_SIGN_CREDENTIALS,
  //   config: { clientId: HELLO_SIGN_CLIENT_ID },
  // },
} = environment;

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  // helloSignOptions = {
  //   headers: new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     Authorization: `Basic ${HELLO_SIGN_CREDENTIALS}`,
  //   }),
  // };

  constructor(private http: HttpClient) {}

  // Camper Cams

  getCampLocations(): Observable<any> {
    return this.http
      .get<any>(`${camUrl}/ws01/locations2`)
      .pipe(map((res) => res.data));
  }

  getCampLocationCameras(campId): Observable<any> {
    return this.http
      .get<any>(`${camUrl}/ws01/camerasV2/${campId}`)
      .pipe(map((res) => res.data));
  }

  // My Profile - Camper Application: HelloSign
  /*
    Due to the limitation on the HellSign, the API could not be consumed from the
      "client-side app". Instead, we have built the backend API to help deal with it.

    TODO: Remove all the commented usages related to HelloSign.
   */
  // createSignatureRequest(
  //   templateId: string,
  //   firstName: string,
  //   lastName: string,
  //   email: string
  // ): Observable<SignatureRequest> {
  //   return this.http.post<SignatureRequestResponse>(`${HELLO_SIGN_URL}/v3/signature_request/create_embedded_with_template`, {
  //     test_mode: 1,
  //     client_id: HELLO_SIGN_CLIENT_ID,
  //     template_id: templateId,
  //     signers: { CpAppUser: { name: firstName + ' ' + lastName, email_address: email } }
  //   }, this.helloSignOptions)
  //     .pipe(map(res => res.signature_request));
  // }

  // getEmbeddedSignUrl(signatureId: string): Observable<string> {
  //   return this.http.get<EmbeddedResponse>(`${HELLO_SIGN_URL}/v3/embedded/sign_url/${signatureId}`, this.helloSignOptions)
  //     .pipe(map(res => res.embedded.sign_url));
  // }

  // getSignatureRequestFileUrl(signatureRequestId: string): Observable<string> {
  //   return this.http.get<any>(`${HELLO_SIGN_URL}/v3/signature_request/files/${signatureRequestId}?get_url=true`, this.helloSignOptions)
  //     .pipe(map(res => res.file_url));
  // }

  // getSignatureRequestStatus(signatureRequestId: string): Observable<boolean> {
  //   return this.http.get<any>(`${HELLO_SIGN_URL}/v3/signature_request/${signatureRequestId}`, this.helloSignOptions)
  //     .pipe(map(res => {
  //       //
  //       return res.signature_request.is_complete;
  //     }));
  // }
}
